export class VehicleVariantDto {

  public id!: string;
  public name!: string;
  public modelId!: string;

  constructor(init?: Partial<VehicleVariantDto> | undefined) {
    Object.assign(this, init);
  }
}
